export const FormComponents = {
  TEXT_FIELD: 'Text',
  TEXT_AREA_FIELD: 'Text Area',
  CONTENT_FIELD: 'Content',
  RADIO_BUTTON: 'Radio Button',
  DROP_DOWN_FIELD: 'Drop Down',
  CHECKBOX_FIELD: 'Checkbox',
  ORDER_OBJECT: 'Order Object',
}
